import { Alert, Collapse, AlertColor } from "@mui/material";
import { createContext, useContext, useState, ReactNode } from "react";

interface AlertContextValue {
  alertOpen: boolean;
  alertType: AlertColor;
  alertMessage: string;
  setAlert: (open: boolean, type?: AlertColor, message?: string) => void;
}

export const AlertContext = createContext<AlertContextValue | undefined>(undefined);

interface AlertProviderProps {
  children: ReactNode;
}

export const AlertProvider = ({ children }: AlertProviderProps) => {
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<AlertColor>("info");
  const [alertMessage, setAlertMessage] = useState<string>("");

  const setAlert = (open: boolean, type: AlertColor = "info", message: string = "") => {
    setAlertOpen(open);
    setAlertType(type);
    setAlertMessage(message);

    if (open) {
      setTimeout(() => {
        setAlertOpen(false);
      }, 5000);
    }
  };

  return (
    <AlertContext.Provider
      value={{
        alertOpen,
        alertType,
        alertMessage,
        setAlert,
      }}
    >
      {children}
      <Collapse in={alertOpen}>
        <Alert severity={alertType} onClose={() => setAlert(false)}>
          {alertMessage}
        </Alert>
      </Collapse>
    </AlertContext.Provider>
  );
};

export const useAlert = (): AlertContextValue => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error("useAlert must be used within an AlertProvider");
  }
  return context;
};

